import React, { useState, useEffect } from 'react';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const images = [
  {
    "src": "/slider/slider3.png",
    "link": "/"
  },
  {
    "src": "/slider/slider2.png",
    "link": "/"
  },
  {
    "src": "/slider/slider1.png",
    "link": "/"
  }
];

const SimpleSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);

  // Sonsuz döngü için cloned array
  const extendedImages = [images[images.length - 1], ...images, images[0]];

  const goToPrevSlide = () => {
    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => prevIndex - 1);
  };

  const goToNextSlide = () => {
    setIsTransitioning(true);
    setCurrentIndex((prevIndex) => prevIndex + 1);
  };

  // Sonsuz döngü mantığı
  useEffect(() => {
    if (currentIndex === 0) {
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(images.length);
      }, 600);
      return () => clearTimeout(timer);
    }
    if (currentIndex === images.length + 1) {
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(1);
      }, 600);
      return () => clearTimeout(timer);
    }
  }, [currentIndex]);

  // Auto-play
  useEffect(() => {
    const intervalId = setInterval(() => {
      goToNextSlide();
    }, 5000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="relative w-full h-auto overflow-hidden group">
      <button onClick={goToPrevSlide} className="absolute top-1/2 left-4 transform -translate-y-1/2 bg-white hover:bg-gray-100 hover:shadow-lg active:scale-95 rounded-full p-2 focus:outline-none z-10 transition-all duration-300 shadow-md text-gray-700 text-lg">
       <FaArrowLeft/>
      </button>
      <button onClick={goToNextSlide} className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-white hover:bg-gray-100 hover:shadow-lg active:scale-95 rounded-full p-2 focus:outline-none z-10 transition-all duration-300 shadow-md text-gray-700 text-lg">
        <FaArrowRight/>
      </button>
      <div 
        className={`flex ${isTransitioning ? 'transition-transform duration-700 ease-in-out' : ''}`}
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {extendedImages.map((image, index) => (
          <img
            key={index}
            src={image.src}
            alt={`Slide ${index + 1}`}
            className="w-full h-auto flex-shrink-0 md:object-cover max-w-full max-h-full min-h-[300px] md:min-h-[500px]"
          />
        ))}
      </div>
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => {
              setIsTransitioning(true);
              setCurrentIndex(index + 1);
            }}
            className={`h-2 rounded-full transition-all duration-300 ${
              index === (currentIndex === 0 ? images.length - 1 : currentIndex === images.length + 1 ? 0 : currentIndex - 1) ? 'bg-primary w-8' : 'bg-white bg-opacity-60 w-2 hover:bg-opacity-100'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default SimpleSlider;
